module.exports = __webpack_public_path__ + "img/480.dba78234.jpg";